module.exports = __webpack_public_path__ + "img/3-1-IMG_3001.5ef15c6a.png";